export function formatCurrencyToNumber(currency: string) {
	const clearValue = currency.replace(/[^\d,]/g, '')

	const valueWithoutPoint = clearValue.replace('.', '')

	const formattedValue = valueWithoutPoint.replace(',', '.')

	return parseFloat(formattedValue)
}
